module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABRCAYAAAATm8x+AAAAGUlEQVQYlWN48ODBfyYGBgaGUWJwEAwMDAAxzgRAbAXBUgAAAABJRU5ErkJggg=="